<script>
import draggable from 'vuedraggable'
import { SIDEBAR_CHAT } from '@modules/aawz-intelligence-v2/constants/TextChat'
import PersonalizacaoItemTile from './personalizacao-item-tile.vue'

// Fileira "ADICIONAR MÓDULO · CLIQUE OU ARRASTE PARA O PAINEL" — os módulos
// OCULTOS do painel de insights, numa faixa ACIMA do canvas (fixa, logo
// abaixo da barra do topo da lateral). Mesmo padrão "paleta → canvas" já usado no CRM
// (summary-layout-form-body.vue): draggable clonável (`pull: 'clone', put:
// false`) + clique no tile tem o MESMO efeito do drag (o item some daqui e
// entra no canvas).
export default {
  name: 'PersonalizacaoPaleta',
  components: {
    draggable,
    PersonalizacaoItemTile,
  },
  props: {
    // `[{id, rotulo, icone}]` — os módulos que NÃO estão no painel.
    itens: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      // Cópia local só para o vuedraggable operar — a paleta não é `put`
      // (`put: false`), então o array nunca recebe item de fora; é clonado
      // para o canvas, nunca movido daqui.
      itensLocais: [],
    }
  },
  computed: {
    texto() {
      return SIDEBAR_CHAT
    },
  },
  watch: {
    itens: {
      immediate: true,
      handler(next) {
        this.itensLocais = (next || []).slice()
      },
    },
  },
  methods: {
    clonarItem(item) {
      return { ...item }
    },
    adicionar(item) {
      this.$emit('adicionar', item.id)
    },
  },
}
</script>

<template>
  <div class="personalizacao-paleta">
    <div class="personalizacao-paleta__titulo ia-sidebar-aux">
      {{ texto.personalizacaoPaletaTitulo }}
    </div>
    <!-- A faixa FICA mesmo sem nada a adicionar (decisão do usuário): sumir
         faria o painel pular de posição ao esvaziar a paleta. -->
    <div
      v-if="!itensLocais.length"
      class="personalizacao-paleta__vazio ia-sidebar-aux"
      data-test="personalizacao-paleta-vazia"
    >
      {{ texto.personalizacaoPaletaVazia }}
    </div>
    <draggable
      v-else
      :list="itensLocais"
      :group="{ name: 'painel-insights', pull: 'clone', put: false }"
      :clone="clonarItem"
      :sort="false"
      :animation="200"
      ghost-class="personalizacao-paleta__ghost"
      class="personalizacao-paleta__lista"
    >
      <button
        v-for="item in itensLocais"
        :key="item.id"
        type="button"
        class="personalizacao-paleta__addable"
        data-test="personalizacao-paleta-item"
        @click="adicionar(item)"
      >
        <PersonalizacaoItemTile
          :id="item.id"
          :rotulo="item.rotulo"
          :icone="item.icone"
        />
      </button>
    </draggable>
  </div>
</template>

<style lang="sass" scoped>
// Fileira horizontal, com quebra de linha — o "Adicionar módulo" do
// protótipo, ACIMA do canvas (a faixa de fundo é de quem a monta,
// `chat-sidebar.vue`).
.personalizacao-paleta
  display: flex
  flex-direction: column
  gap: 8px
  flex-shrink: 0

  // Tipografia toda do `.ia-sidebar-aux` (dono único do passo da lateral);
  // o itálico é o que separa a observação do título.
  &__vazio
    font-style: italic
    // Mesma altura de uma fileira de tiles (36px + borda), pra a faixa não
    // encolher quando o último módulo entra no painel.
    // = altura do tile (36px, border-box): a faixa não muda de altura entre
    // "tem tile" e "não tem mais nada".
    min-height: 36px
    display: flex
    // Encostado na BASE do slot (com 6px de folga), não centrado: centrado,
    // sobravam ~12px de ar abaixo do texto que a fileira de tiles não tem,
    // e a faixa parecia mais alta embaixo só neste estado (medido com o
    // usuário). Assim "última linha → base" fica igual nos dois estados.
    align-items: flex-end
    padding-bottom: 6px

  // `gap: 6px` (não 8): com os 9 módulos do catálogo e tiles de 36px, é o
  // que faz TODOS caberem numa fileira só nos 376px úteis da coluna
  // (9×36 + 8×6 = 372) — com 8 quebrava em duas linhas, e a faixa mudava de
  // altura conforme os módulos entravam no painel (achado do usuário).
  &__lista
    display: flex
    flex-wrap: wrap
    gap: 6px

  &__addable
    display: block
    padding: 0
    margin: 0
    border: none
    background: transparent
    font: inherit
    cursor: grab

    &:focus-visible
      border-radius: var(--radius-sm)
      box-shadow: 0 0 0 2px var(--primary)

  &__ghost
    opacity: 0.4
</style>
